import React, { useState, useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import UpdatePackageSalesUserRole from "./UpdatePackageSalesUserRole";
import Preloader from "../../../components/Preloader/Preloader";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
		maxHeight:"100%",
		overflow: "auto"
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function UpdateUserRole(props) {
	const [loading, setLoading] = useState(false);
	const {position_id, position_name, showModal} = props;
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [modalData, setModalData] = useState([]);
	const [userRoleData, setUserRoleData] = useState([]);
	const [positionName, setPositionName] = useState('');
	const [canProcess, setCanProcess] = useState(0);
	const [canEdit, setCanEdit] = useState(0);
	const [canDelete, setCanDelete] = useState(0);
	const [canApprove, setCanApprove] = useState(0);

	const handleOpen = () => {
		getSingleUserRoleData();
		getUserRoleData();
		setOpen(true);

	};

	const handleClose = () => {
		setOpen(false);
	};

	const getUserRoleData = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'add_user_role_data', {
			}).then(function (res) {
				setModalData(res.data.data);
		
		  	}).catch(function (error) {	
				// console.log(error);
	  		});
	}
	const getSingleUserRoleData = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'get_single_user_role', {
			params:{
				position_id
			}
			}).then(function (res) {
				setUserRoleData(res.data.data.position);
				setCanApprove(res.data.data.position.can_approve.toString());
				setCanEdit(res.data.data.position.can_edit.toString());
				setCanDelete(res.data.data.position.can_delete.toString());
				setCanProcess(res.data.data.position.can_process.toString());
				setLoading(true);
		  	}).catch(function (error) {	
				// console.log(error);
	  		});
	}

	useEffect(() => { //
		getUserRoleData(); //data to display the checkboxes
		 //data for existing user role
		setPositionName(position_name);
	}, []);

	const removeDuplicates = (array) => {
		return [...new Set(array)];
	}

	const updateUserRole = async (positionName, main_nav, content_nav, ps_nav_data, canApprove, canDelete, canEdit,canProcess) => {

		if(positionName && main_nav && content_nav){
			const formData = new FormData();
			formData.append("position_id", position_id);
			formData.append("position", positionName);
			formData.append("main_nav", main_nav);
			formData.append("content_nav", content_nav);
			formData.append("ps_nav_data", ps_nav_data);
			formData.append("approve", canApprove);
			formData.append("delete", canDelete);
			formData.append("edit", canEdit);
			formData.append("process", canProcess);
		
			await axios.post(process.env.REACT_APP_API_URL+'update_user_role', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
				}).then(function (res) {
					showModal('Updated User Role '+ positionName, 'success');
					getSingleUserRoleData();
					handleClose();
				  }).catch(function (error) {
					showModal('Something went wrong '+ error.message, 'warning');
					handleClose();
				  });
		}else{
			showModal('Something went wrong '+ 'Fields must not be empty', 'warning');
			handleClose();
		}
	}

	const handleSubmit = (e) => {
		e.preventDefault();

		//get all checked checkboxes / preparing content_nav
		const content_nav = Array.from(e.currentTarget.elements).filter(el => 
		(el.checked && el.getAttribute('type') === 'checkbox' && el.getAttribute('name').includes('ps') == false && el.getAttribute('value') != "action")).map(el => el.value);

		//get all checked checkboxes / preparing main_nav
		const main_nav_data = Array.from(e.currentTarget.elements).filter(el => 
		(el.checked && el.getAttribute('type') === 'checkbox' && el.getAttribute('name').includes('ps') == false && el.getAttribute('value') != "action")).map(el => el.name);
		
		//get all checked checkboxes / preparing package sales nav
		const ps_nav_data = Array.from(e.currentTarget.elements).filter(el => 
		(el.checked && el.getAttribute('type') === 'checkbox' && el.getAttribute('name').includes('ps') && el.getAttribute('value') != "action")).map(el => el.value);

		const main_nav = removeDuplicates(main_nav_data);
		//sort numbers in ascending order
		main_nav.sort = (a,b) => {
			return a-b;
		}
		content_nav.sort = (a,b) => {
			  return a-b;
		}
		ps_nav_data.sort = (a,b) => {
			return a-b;
	  	}
		// console.log(main_nav.toString()); //convert array to comma seperated strings
		// console.log(content_nav.toString()); //convert array to comma seperated strings
		// console.log(ps_nav_data.toString());
		updateUserRole(positionName, main_nav, content_nav, ps_nav_data, canApprove, canDelete, canEdit,canProcess);
    }

	const isChecked = (id) => {
		if(userRoleData.access_content_nav){
			// console.log('id: '+ id);
			// console.log("testing",userRoleData.access_content_nav);
			//console.log(userRoleData.access_content_nav.includes(id));

			//will check  the checkbox if current user already has access to that content nav
			return userRoleData.access_content_nav.includes(id); 
		}
	}

	const handleChanges = event => {
		if (event.target.checked) {
		  	switch (event.target.getAttribute('name')) {
			case "process":
				setCanProcess(1);
			break;
			case "edit":
				setCanEdit(1);
				break;
			case "delete":
				setCanDelete(1);
				break;
			case "approve":
				setCanApprove(1);
				break;
			default:
				break;
			}
		} else {
			switch (event.target.getAttribute('name')) {
				case "process":
				setCanProcess(0);
				break;
				case "edit":
					setCanEdit(0);
					break;
				case "delete":
					setCanDelete(0);
					break;
				case "approve":
					setCanApprove(0);
					break;
				default:
					break;
		}
	  }

	}

	// const handleCheck = (e) => {
	// 	console.log(e.target.checked);
	// 	// e.target.checked = !e.target.checked;
	// 	// e.target.checked = e.target.checked;
	// };

	return (
		<div>
			<Button variant="contained" color="primary" onClick={handleOpen} style={{backgroundColor: "#4caf50", color:"#fff"}}>
				Edit
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<h2 id="transition-modal-title">Update User Role</h2>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={3}>
							<h4>Access</h4>
							<Grid  container direction="row" justifyContent="center" alignItems="center"xs={12} >
								
										<Grid item xs={3}>
												<FormControlLabel
													control={
													  <Checkbox
													    onChange={handleChanges}
														name="approve"
														value="action"
														color="primary"
														checked={canApprove == 1 ? true  : false}
													  />
													}
													label="Approve"
												  />
												</Grid>
												<Grid item xs={3}>
												<FormControlLabel
													control={
													  <Checkbox
													    onChange={handleChanges}
														name="edit"
														value="action"
														color="primary"
														checked={canEdit == 1 ? true : false}
													  />
													}
													label="Edit"
												  />
												</Grid>
												<Grid item xs={3}>
												<FormControlLabel
													control={
													  <Checkbox
													    onChange={handleChanges}
														name="delete"
														value="action"
														color="primary"
														checked={canDelete == 1 ? true : false}
													  />
													}
													label="Delete"
												  />
												</Grid>
												<Grid item xs={3}>
												<FormControlLabel
													control={
													  <Checkbox
													    onChange={handleChanges}
														name="process"
														value="action"
														color="primary"
														checked={canProcess == 1 ? true : false}
													  />
													}
													label="Process"
												  />
												</Grid>
									</Grid>	
							<Grid item xs={12} xl={12}> 
								<Input style={{marginTop:  "21px"}} 
								fullWidth={true} 
								defaultValue={position_name}
								placeholder="Position" 
								inputProps={{ 'aria-label': 'Position' }}
								onChange={e => setPositionName(e.target.value)}/>
							</Grid>
							{loading ? modalData.map((main_nav)=>{
								return(
									<React.Fragment key={main_nav.title+main_nav.length}>
									<Grid item xs={12} key={main_nav.title}>
										<h4>{main_nav.title}</h4>
									</Grid>	
										{main_nav.data.map((content_nav)=>{
											return(
												<Grid item xs={6} key={content_nav.id}>
												<FormControlLabel
													control={
													  <Checkbox
														//checked={()=>{userRoleData.access_content_nav.includes(content_nav.cn_fkey)}}
														//wrong approach, try to use event click, check displays but, not clickable
														//onChange={(e)=>{handleCheck(e, isChecked(String(content_nav.cn_fkey)))}}
														// checked={isChecked(String(content_nav.cn_fkey))}
														//defaultChecked={isChecked(String(content_nav.cn_fkey))}
														defaultChecked={isChecked(content_nav.id.toString())}
														name={content_nav.cn_fkey}
														value={content_nav.id}
														color="primary"
													  />
													}
													label={content_nav.cn_name}
												  />
												</Grid>
											)
										})}
									</React.Fragment>
								)
							})
							: (<Preloader />)}
					<UpdatePackageSalesUserRole position_id={position_id}/>
							</Grid>
							<div className={classes.button}>
								
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<Button type="submit" variant="contained" color="primary">
									Save
								</Button>
							</div>
						</form>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
